<!-- 关联设备项 -->
<template>
  <div class="w-100">
    <div>
      <div
        class="w-100 uk-flex item border"
        :key="device.id"
        v-for="device in relatedDeviceList"
      >
        <div
          class="bg-theme color-white  uk-text-center ellipsis"
          style="width: 140px;"
          :title="device.name"
        >
          {{ device.name }}
        </div>
        <div class="uk-flex-1 uk-flex uk-text-center">
          <div class="button bd-r bd-l">
            <i
              v-if="device.deviceType"
              :class="
                equiIconConvert(device.deviceCatalog, device.deviceType).icon
              "
              :title="
                equiIconConvert(device.deviceCatalog, device.deviceType).title
              "
            ></i>
            <i
              v-else-if="device.changeDeviceType"
              :class="
                equiIconConvert(device.changeDeviceCatalog, device.changeDeviceType).icon
              "
              :title="
                equiIconConvert(device.changeDeviceCatalog, device.changeDeviceType).title
              "
            ></i>
          </div>
          <!-- 是否使用底座 -->
          <div class="button bd-r">
            <i
              class="iconfont icon-dianjidizuo"
              :class="{ 'color-gray': !device.plinthId }"
              :title="
                device.plinthId
                  ? (device.plinthType? `${$t(baseType[device.plinthType].title)}:${
                      device.plinthCode
                    }` : device.plinthId)
                  : $t('integration.smart_sled_not_bound')
              "
            ></i>
          </div>
          <!-- 底座名称 -->
          <template>
            <div style="width: 160px;">
              {{ device.deviceCode || $t('device.device_not_bind') }}
            </div>
            <div class="bd-l button">
              <i
                class="el-icon-tickets"
                :title="$t('integration.details')"
                :style="{ cursor: device.deviceCode ? 'pointer' : 'not-allowed', opacity: device.deviceCode ? '1' : '0.5' }"
                @click="deviceDetail(device)"
              ></i>
            </div>
            <div class="bd-l button">
              <i
                class="iconfont icon-charutupian"
                :title="$t('integration.picture')"
                @click="devicePicture(device)"
              ></i>
            </div>
            <!--<div class="bd-l button">-->
            <!--  <i-->
            <!--    class="iconfont icon-charutupian "-->
            <!--    :title="$t('integration.picture')"-->
            <!--    @click="devicePicture(device)"-->
            <!--  ></i>-->
            <!--</div>-->
            <div class="bd-l button">
              <i
                class="iconfont icon-zhexiantu"
                :title="$t('integration.historical_data_')"
                @click="toHistory(device)"
              ></i>
            </div>
          </template>

          <!-- 切换的设备-->
          <!-- 切换完成后，不需要显示切换设备和切换时间等-->
          <template v-if="device.status !== 2 ">
            <div style="width: 160px;" class="bd-l button">
              {{ device.changeDeviceCode || $t('device.device_not_bind') }}
            </div>
            <div class="bd-l button">
              <i
                class="el-icon-tickets"
                :title="$t('integration.details')"
                :style="{ cursor: device.deviceCode ? 'pointer' : 'not-allowed', opacity: device.deviceCode ? '1' : '0.5' }"
                @click="deviceDetail(device)"
              ></i>
            </div>
            <div class="bd-l button">
              <i
                class="iconfont icon-charutupian"
                :title="$t('integration.picture')"
                @click="devicePicture(device)"
              ></i>
            </div>
            <div class="bd-l button">
              <i
                class="iconfont icon-zhexiantu"
                :title="$t('integration.historical_data_')"
                @click="toHistory(device)"
              ></i>
            </div>
            <!-- 切换时间 -->
            <div class="bd-l button" style="width:180px;">
              <!-- {{ device.change_time }}{{ $t(switchTimeConvert(device.change_time_type).title) }} -->

              <div :uk-countdown="getRemainingTime(device)" ref="countdown"
                v-if="device.status === 1">
                <span class="uk-countdown-number uk-countdown-days"></span>
                <span class="uk-countdown-separator">{{ $t('task.detection_interval_day') }}</span>
                <span class="uk-countdown-number uk-countdown-hours"></span>
                <span class="uk-countdown-separator">{{ $t('task.detection_interval_hour') }}</span>
                <span class="uk-countdown-number uk-countdown-minutes"></span>
                <span class="uk-countdown-separator">{{ $t('task.detection_interval_minute') }}</span>
              </div>
            </div>
            <div class="bd-l button">
              <i class="el-icon-refresh"
              :style="{color: device.status === 1 ? 'var(--primary-color)': '#aaa'}"
              @click="resetRemainTime(device)"></i>
            </div>
          </template>
          <!-- 底座描述 -->
          <div class="uk-flex-1 bd-l">
            <tooltip :text="device.description">
              <span>
                {{ device.description }}
              </span>
            </tooltip>
          </div>
        </div>
        <div class="uk-text-center uk-flex">
          <!-- 切换 -->
          <!-- 状态 0-待切换，1-切换中，2-切换完成，3-切换失败 -->
          <div class="bd-l button" v-if="device.status === 0 || device.status === 3 || !device.status">
            <i
              class="el-icon-circle-check"
              :title="$t('device.start_switch')"
              style="color: green;"
              @click="startSwitch(device)"
            ></i>
          </div>
          <!-- 终止切换 -->
          <div class="bd-l button" v-if="device.status === 1">
            <i
              class="el-icon-circle-close"
              :title="$t('device.stop_switch')"
              style="color: red;"
              @click="stopSwitch(device)"
            ></i>
          </div>
          <div class="bd-l button">
            <el-popover
              v-if="detailObj.sceneId"
              placement="top-start"
              width="850"
              trigger="hover"
              :popper-append-to-body="true"
              @show="alarmStrategyShow(device)"
              append-to-body
            >
              <AlarmStrategy
                v-if="currentSensorStrategy.id === device.id"
                :strategy="device"
                :forwardPlatform="forwardList"
                :units="units"
                :scopeId="detailObj.sceneId"
              >
              </AlarmStrategy>
              <i
                class="el-icon-setting"
                :title="$t('integration.set_up')"
                slot="reference"
              ></i>
            </el-popover>
          </div>
          <!-- <div class="bd-l button">
            <i
              class="el-icon-tickets"
              :title="$t('integration.details')"
              @click="deviceDetail(device)"
            ></i>
          </div>
          <div class="bd-l button">
            <i
              class="iconfont icon-zhexiantu"
              :title="$t('integration.historical_data_')"
              @click="toHistory(device)"
            ></i>
          </div> -->
        </div>
      </div>
    </div>

    <el-button
      type="primary"
      class="uk-margin-small-right"
      @click="editRelateDevice"
      >{{ $t('integration.edit') }}
    </el-button>
    <el-button type="primary" @click="toCarrierProbeHistory"
      >{{ $t('integration.chart') }}
    </el-button>

    <EditRelateDevice
      :relationList="relatedDeviceList"
      :show.sync="relateDeviceDiaShow"
      :forwardPlatform="forwardList"
      :units="units"
      :scopeId="detailObj.sceneId"
      :carrierInfo="carrierInfo"
      @getList="getRelationList"
    >
    </EditRelateDevice>

    <DevicePicture
    :visibleShow.sync = "pictureDiaShow"
    :carrierDeviceId = "carrierDeviceId"
    />
  </div>
</template>

<script>
import AlarmStrategy from './components/AlarmStrategy.vue'
import {
  carrierRelectList,
  shareForward,
  shareUnit,
  carrierChangeStart,
  carrierChangeStop,
} from '@/api/modules/carrier.js'

import { carrierProbeHistory, probeHistory } from '@/utils/winDetail'
import EditRelateDevice from '@/pages/business/components/detail/carrierDetail/components/realteDevice/components/EditRelateDevice'
import {
  baseType,
  equiIconConvert,
  equiType,
  sampleSrategy,
  switchTimeConvert
} from '@/utils/convert'

import tooltip from '@/pages/system/resource/components/tooltip'
import { getCarrierInfoBrief } from '@/utils/simplify/carrierInfoBrief'

import DevicePicture from './components/DevicePicture.vue'


export default {
  props: ['detailObj'],
  components: {
    AlarmStrategy,
    DevicePicture,
    EditRelateDevice,
    tooltip
  },
  computed: {
    sampleSrategy: () => sampleSrategy,
    equiIconConvert: () => equiIconConvert,
    equiType: () => equiType,
    baseType: () => baseType,
    carrierInfo () {
      return getCarrierInfoBrief(this.detailObj)
    },
    switchTimeConvert: () => switchTimeConvert
  },
  data () {
    return {
      // 转发平台列表 要往下传
      forwardList: [],

      // 已关联设备列表
      relatedDeviceList: [],

      // 关联设备对话框
      relateDeviceDiaShow: false,
      pictureDiaShow: false,
      carrierDeviceId: 0,
      // 传感器报警策略缓存
      strategyCache: {},
      currentSensorStrategy: {},
      // 计量单位
      units: []
    }
  },
  methods: {
    getForward () {
      if (this.forwardList.length) {
        return
      }
      // 获取转发平台
      shareForward().then(({ result }) => {
        result.splice(0, 0, {
          id: 0,
          name: $t('integration.please_select')
        })
        this.forwardList = result
      })
    },
    // 获取已关联设备
    // async getRelatedList() {
    //     const params = {
    //         devCatalog: 0,
    //         devType: 1,
    //         mode: 'carry',
    //         carrierId: this.detailObj['id'] || this.$route.query.id,
    //         scope: this.detailObj['scene_id']
    //     };

    //     // return carrierRelated(this.listQuery, this.$attrs.getCarrierType['id'])

    //     this.relatedDeviceList = (await carrierRelated(params, this.$route.query.type)).result;
    // },

    // 设备详情 暂智能查询传感器详情
    deviceDetail (row) {
      if (!row.deviceCode) {
        return;
      }
      // 0123 传感器 网关 显示屏 中继
      const { deviceCatalog } = row
      let pathFull = ''
      if (deviceCatalog === 0) {
        pathFull = '/SensorDetail'
      } else if (deviceCatalog === 1) {
        pathFull = '/GateWayDetail'
      } else if (deviceCatalog === 2) {
        pathFull = '/DisplayDetail'
      } else if (deviceCatalog === 3) {
        pathFull = '/RelayDetail'
      } else if (deviceCatalog === 4) {
        pathFull = '/BaseDetail'
        // 智能底座详情
        // pathFull = ''
      }

      const { href } = this.$router.resolve({
        path: pathFull,
        query: {
          id: row.deviceId,
          name: row.deviceCode
        }
      })
      window.open(
        href,
        '_blank',
        'height=800,width=1200,top=200,left=200,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no'
      )
    },

    devicePicture (device) {
      this.pictureDiaShow = true;
      this.carrierDeviceId = device.id;
    },
    // 查看传感器历史数据
    toHistory (row) {
      // 只有底座和传感器才有历史数据
      if (!row.code || (row.deviceCatalog !== 0 && row.deviceCatalog !== 4)) {
        return this.$message.warning(
          $t('integration.this_device_has_no_historical_data')
        )
      }
      probeHistory(
        row.carrierId,
        this.detailObj.keycode,
        this.detailObj.typeId,
        row.code,
        row.name,
        row.deviceType,
        this.detailObj.fullPath
      )
      // sensorHistory(row.id, row.tagId, row.probe_value, this.detailObj.scopeName, this.detailObj.keycode, this.detailObj.id, this.detailObj.typeId);
    },
    toCarrierProbeHistory (row) {
      const { id, typeId, keycode, description } = this.detailObj
      carrierProbeHistory({
        carrierId: id,
        type: typeId,
        carrierName: keycode,
        description,
        carrierInfo: this.detailObj
      })
    },
    // 编辑关联设备 点击编辑按钮触发
    editRelateDevice () {
      this.relateDeviceDiaShow = true
    },
    alarmStrategyShow (row) {
      this.currentSensorStrategy = row
    },
    // 获取关联映射列表
    getRelationList (callback) {
      const { type, id } = this.$route.query

      carrierRelectList(type, id).then(res => {
        this.relatedDeviceList = res.result
        this.$nextTick(() => {
          // 有回调则执行回调
          if (callback) {
            callback()
          }
        })
      })
    },
    async getUnits () {
      if (!this.units.length) {
        const units = await shareUnit()
        this.units = units.result
      }
    },
    // 终止切换
    stopSwitch(device){
      carrierChangeStop(device.id).then(res => {
        if (res.state.code === 200) {
          this.$message.success($t('integration.success'))
          this.getRelationList()
        }
      })
    },
    // 开始切换
    startSwitch(device){
      carrierChangeStart(device.id).then(res => {
        if (res.state.code === 200) {
          this.$message.success($t('integration.success'))
          this.getRelationList()
        }
      })
    },
    // 计算剩余切换时间
    getRemainingTime(device){
      let  addTime = device.changeTime
      if(device.changeTimeType === 1){ // 单位：分
        addTime = addTime * 60 * 1000
      }else if (device.changeTimeType === 2){ // 单位：时
        addTime = addTime * 60 * 60 * 1000
      }else{
        addTime = addTime * 24 * 60 * 60 * 1000
      }

      // this.remainingTime = res.result.start_time + addTime
      let remainingTime = 'date:' +  this.$timetransition(device.startTime + addTime)
      this.$set(device, 'remainingTime', remainingTime)
      return remainingTime
    },
    resetRemainTime(device){
      this.getRemainingTime(device)
    }
  },
  mounted () {
    this.getForward()

    this.getUnits()
  }
}
</script>

<style lang="scss" scoped>
.item {
  height: 35px;
  line-height: 35px;
  border-radius: 2px;
  margin-bottom: 5px;

  .button {
    width: 30px;
    cursor: pointer;
  }
}
::v-deep .uk-countdown {
  display: inline-block;
}
.uk-countdown-separator {
  font-size: 14px !important;
}
.uk-countdown-number {
  font-size: 14px !important;
}

</style>
